import React from 'react';

export function Input({ className = '', ...props }: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input 
      className={`w-full bg-[var(--color-csai-bg)] border border-[#c4b9ae] rounded-md px-4 py-2 text-[var(--color-csai-accent)] focus:outline-none focus:border-[var(--color-csai-primary)] focus:ring-1 focus:ring-[var(--color-csai-primary)] transition-colors ${className}`}
      {...props}
    />
  );
}
